// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_SalvarAtributosCategoriaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/item_attributes/salvar_atributos_categoria/{category_id}
 *
 * Bulk replaces the attribute bindings for a service category. Returns
 * the count of bindings now persisted for that category.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Item_attributes_SalvarAtributosCategoriaResponseDados {
count: number
}

export type Item_attributes_SalvarAtributosCategoriaResponse = ApiResponse<Item_attributes_SalvarAtributosCategoriaResponseDados>;

registerResponseContract('Item_attributes_SalvarAtributosCategoriaResponse', {
  count: { type: 'number',  required: true },
})
